import React from "react";
import { motion } from "framer-motion";
import { SEGMENTS, GALLERY } from "../../data/hseData";

export const Segments = () => {
  return (
    <section id="segmentos" data-testid="section-segmentos" className="relative py-24 sm:py-32 bg-[#0B1B2D]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#2FA36B]" />
              <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
                Segmentos atendidos
              </span>
            </div>
            <h2 className="font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
              Atuação em
              <span className="text-[#2FA36B]"> indústrias</span> que não podem parar.
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/65 font-body text-base leading-relaxed">
            Apoiamos operações industriais críticas em diferentes setores, sempre com foco em segurança, controle de risco e continuidade operacional.
          </p>
        </div>

        {/* Segments grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-white/[0.07] border border-white/[0.07] mb-16">
          {SEGMENTS.map((s, i) => (
            <motion.div
              key={s}
              data-testid={`segment-${i}`}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: (i % 4) * 0.05 }}
              className="bg-[#12283F] hover:bg-[#2FA36B] transition-colors p-5 sm:p-6 group cursor-default"
            >
              <span className="font-condensed font-bold text-[10px] tracking-[0.25em] uppercase text-white/30 group-hover:text-white/70 block mb-2">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-condensed font-bold uppercase text-sm sm:text-base text-white tracking-tight leading-tight block">
                {s}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Gallery */}
        <div>
          <div className="flex items-end justify-between mb-8 gap-4 flex-wrap">
            <div>
              <div className="inline-flex items-center gap-3 mb-3">
                <span className="w-8 h-px bg-[#2FA36B]" />
                <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">
                  Galeria
                </span>
              </div>
              <h3 className="font-condensed font-bold uppercase text-2xl sm:text-3xl text-white tracking-tight">
                Operação em campo
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.07] border border-white/[0.07]">
            {GALLERY.map((g, i) => (
              <motion.div
                key={i}
                data-testid={`gallery-item-${i}`}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="relative aspect-[4/3] overflow-hidden group bg-[#0B1B2D]"
              >
                <img
                  src={g.url}
                  alt={g.label}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between">
                  <span className="font-condensed font-bold uppercase text-sm sm:text-base text-white tracking-tight">
                    {g.label}
                  </span>
                  <span className="font-condensed font-bold text-[10px] tracking-[0.3em] uppercase text-[#2FA36B]">
                    HSE / 0{i + 1}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Segments;
